"use strict";

/**
 * Use a stub for MaskedView on all Platforms that don't support it.
 */

export function MaskedView({
  children
}) {
  return children;
}
//# sourceMappingURL=MaskedView.js.map